import '../style.scss'
import { RiCloseFill } from "react-icons/ri"
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, CustomContainer, GridContainer, AppText } from "src/style"
import {ReactComponent as CopyIcon} from 'src/assets/img/copy-icon.svg'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { useNotifier } from "react-pop-notifier"
import { CONSTANTs } from 'src/provider/config/constant';

export const TransferAccountDetails: React.FC<any> = ({next, close}) => {
    const {notifier} = useNotifier()

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Pay with Bank Transfer</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#667085'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <GridContainer 
                    topMargin="2" minHeight="28.4"
                    radius='0.8' borderColor='#A0A4A8'
                    padding='3'
                >
                    <CustomContainer>
                        <AppText 
                            textSize='3.2'fontWeight='500' 
                            color='#000000' align='center'
                        >
                            {CONSTANTs.qoreBank}
                        </AppText>
                        <FlexRow gap='1' justifyContent='center'>
                            <AppText 
                                textSize='3.2'fontWeight='500' 
                                color='#000000' align='center'
                            >
                                {CONSTANTs.qoreAccountNumber}
                            </AppText>
                            <CopyToClipboard 
                                text={CONSTANTs.qoreAccountNumber}
                                onCopy={() => notifier.show("Account number copied successfully", 'Account Number', 'success')}
                            >
                                <CopyIcon />
                            </CopyToClipboard>
                        </FlexRow>
                    </CustomContainer>

                    {/* <AppText 
                        color='#000000' align='center' 
                        topMargin='2.5'
                    >
                        Use this account for this transaction only Account expires in 30 minutes
                    </AppText>
                    <AppText
                        textSize='3' color='#0D968F' 
                        fontWeight='600' topMargin='2'
                    >
                        29:59
                    </AppText> */}
                    <AppText 
                        color='#000000' align='center' 
                        topMargin='2.5'
                    >
                        After the completed transfer, please reach out to your RM with the transfer receipt and ask him/ her to provide value to your baap wallet
                    </AppText>
                </GridContainer>
                <FlexRow justifyContent='flex-end' topMargin='2'>
                    <Button
                        width='9.5'
                        height='4' radius='0.8'
                        bottomMargin='1' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={next}
                    >
                        Continue
                    </Button>
                </FlexRow>
            </FlexColumn>
        </>
    )
}